import {useStyles} from '../../shared/hooks/styles';
import {DeviceSize} from '../../shared/theme/helpers';

export default () =>
  useStyles(({isDesktop, theme, mediaOnly}) => {
    return {
      con: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: isDesktop ? 27 : 0,
      },
      text: {
        ...theme.fonts.h5Light,
        color: theme.color.mainPageTextNameColor,
      },
      engine: {
        position: 'absolute',
        right: 0,
      },
      sectionContainer: {
        marginTop: 58,
        paddingHorizontal: 24,
        paddingBottom: 112,
      },
      gradientContainer: {
        paddingTop: 32,
        paddingBottom: isDesktop ? 11 : 10,
      },
      newsContainer: {
        ...mediaOnly(
          DeviceSize.desktop,
          {
            paddingTop: 63,
            paddingBottom: 112,
          },
          {
            paddingTop: 29,
            paddingBottom: 8,
            paddingHorizontal: 0,
          },
        ),
        paddingTop: 32,
      },
      titleContainerDesktop: {...theme.fonts.h2, marginBottom: 24},
      titleContainerMobile: {...theme.fonts.h6, marginBottom: 26, textAlign: 'center'},
    };
  });
